export class GmapsTravelMode {
  travelMode: string;
  iconUrl: string;

  constructor(travelMode: string, iconUrl: string) {
    this.travelMode = travelMode;
    this.iconUrl = iconUrl;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/gmaps/gmaps-interface/gmaps-travel-mode.model.ts